import { render, staticRenderFns } from "./BrokerForm.vue?vue&type=template&id=655b1640&scoped=true"
import script from "./BrokerForm.vue?vue&type=script&lang=js"
export * from "./BrokerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b1640",
  null
  
)

export default component.exports